import React from 'react';
import { Button, TextField, Typography, MenuItem } from '@mui/material';
import FullScreenDialog from 'components/shared/FullScreenDialog';


interface OrderDialogProps {
  open: boolean;
  selectedSort: string;
  onClose: () => void;
  handleSortChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  applySort: () => void;
}

const OrderDialog: React.FC<OrderDialogProps> = ({
  open,
  selectedSort,
  onClose,
  handleSortChange,
  applySort,
}) => {
  return (
    <FullScreenDialog
      open={open}
      onClose={onClose}
      title={
        <Typography
          sx={{
            fontFamily: 'Roboto',
            fontSize: '24px',
            fontWeight: 500,
            lineHeight: '38.4px',
            letterSpacing: '0.15px',
            textAlign: 'left',
          }}
        >
          Ordenar
        </Typography>
      }
      dialogHeight='280px'
      actions={
        <>
          <Button
            variant='contained'
            size='medium'
            sx={{ backgroundColor: '#0048B6' }}
            onClick={applySort}
          >
            confirmar
          </Button>
          <Button size='medium' onClick={onClose}>
            voltar
          </Button>
        </>
      }
    >
      <TextField
        select
        label='Ordenar'
        value={selectedSort}
        onChange={handleSortChange}
        size='small'
        fullWidth
        sx={{
          height: '72px',
          marginTop: '10px',
        }}
        InputLabelProps={{
          sx: {
            left: '5px',
            top: '5px',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '12px',
            letterSpacing: '0.15px',
            color: '#00000099',
          },
        }}
        SelectProps={{
          sx: {
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',
            letterSpacing: '0.15px',
            color: '#000000DE',
            textAlign: 'left',
          },
        }}
      >
        <MenuItem
          key='recent'
          value='DESC'
          sx={{
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',
            letterSpacing: '0.15px',
            textAlign: 'left',
          }}
        >
          Do mais recente ao mais antigo
        </MenuItem>
        <MenuItem
          key='oldest'
          value='ASC'
          sx={{
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',
            letterSpacing: '0.15px',
            textAlign: 'left',
          }}
        >
          Do mais antigo ao mais recente
        </MenuItem>
      </TextField>
    </FullScreenDialog>
  );
};

export default OrderDialog;
